module.exports = __webpack_public_path__ + "ffd4c9d0f420aad0b34c438e21a16405.jpg";